import { render } from "./formal_document_template_section_editor_view.html?vue&type=template&id=441f276c&scoped=true&external"
import script from "./formal_document_template_section_editor.js?vue&type=script&lang=js&external"
export * from "./formal_document_template_section_editor.js?vue&type=script&lang=js&external"

import "./FormalDocumentTemplateSectionEditor.vue?vue&type=style&index=0&id=441f276c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-441f276c"]])

export default __exports__